import { render } from "./ConfirmOrder.vue?vue&type=template&id=aaca0816&scoped=true"
import script from "./ConfirmOrder.vue?vue&type=script&lang=js"
export * from "./ConfirmOrder.vue?vue&type=script&lang=js"

import "./ConfirmOrder.vue?vue&type=style&index=0&id=aaca0816&lang=scss&scoped=true"
import "./ConfirmOrder.vue?vue&type=style&index=1&id=aaca0816&lang=scss"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaca0816"]])

export default __exports__